export default function hamburger() {
	const items = document.querySelectorAll('#menu_main > .menu-item-has-children');
	let showDelay = 100, hideDelay = 200;
	let menuEnterTimer, menuLeaveTimer;

	items.forEach(link => {
  
			link.addEventListener('mouseenter', (el)=>{
					clearTimeout(menuLeaveTimer);
					let submenu = link.querySelector('.sub-menu');
					for (let j = 0; j < items.length; j++) {
							let innerEl = items[j].querySelector('.sub-menu');
							if(items[j]!==link){
									innerEl.classList.remove('active')
							}
		}
					menuEnterTimer = setTimeout(function() {
			submenu.classList.add('active');
		}, showDelay);
				
			 
			})

			link.addEventListener('mouseleave', (el)=>{
					let submenu = link.querySelector('.sub-menu');
					clearTimeout(menuEnterTimer);
					menuLeaveTimer = setTimeout(function() {
							submenu.classList.remove('active')
					}, hideDelay);
		
			})
		 
	});
	
}
